import { z } from 'zod';

export enum OrgRole {
  ADMIN = 'admin',
  MEMBER = 'member',
  OWNER = 'owner',
}

export const orgRoleSchema = z.nativeEnum(OrgRole);

export const orgRoleOptions = Object.values(OrgRole);

export type OrgRoleInput = z.infer<typeof orgRoleSchema>;
